import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

import { cn } from '../lib/cn.js';

const badgeVariants = cva(
  [
    'inline-flex items-center gap-1.5 rounded-full border px-3 py-0.5',
    'font-sans text-[12px] font-medium leading-none tracking-snug',
    'transition-colors duration-200 ease-jq',
  ].join(' '),
  {
    variants: {
      variant: {
        default: 'border-transparent bg-jq-action-primary text-jq-action-primary-fg',
        secondary: 'border-transparent bg-jq-action-secondary text-jq-action-secondary-fg',
        outline: 'border-jq-fg-brand/25 bg-transparent text-jq-fg-brand',
        accent: 'border-transparent bg-jq-action-accent/15 text-jq-fg-accent',
        success: 'border-transparent bg-jq-success/15 text-jq-success',
        warning: 'border-transparent bg-jq-warning/15 text-jq-warning',
        danger: 'border-transparent bg-jq-danger/15 text-jq-danger',
        info: 'border-transparent bg-jq-info/15 text-jq-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
